module.exports = __webpack_public_path__ + "static/img/compacted-coal_256.5738df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compacted-coal_256.png
// module id = 3JeK
// module chunks = 0